// @ts-nocheck
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function CncLathe(props) {
  const { nodes, materials } = useGLTF('/models3d/cnc_lathe.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.model.geometry}
        material={materials.place_holder}
        rotation={[Math.PI / 2, 0, 0]}
      />
    </group>
  )
}

//useGLTF.preload('/models3d/cnc_lathe.glb')